import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { Dictionary } from "../Utils/Dictionary";
import { FdbTable, FdbEntry } from "../Core/FdbTable";
import { MacAddress } from "../Core/MacAddress";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { HashSet } from "../Utils/HashSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface BridgePortFdbEntryJson {
//	bridge_port_fdb_entry: FdbEntryJson;
//}

//export class BridgePortFdbEntry implements ObjectSerializer {

//    constructor(bpIndex?: number) {
//        this.BpIndex = bpIndex;
//        this.IfName = "";
//        this.MacAddress = null;
//        this.RemoteDevice = null;

//    }

//    public BpIndex: number;
//    public get HasBpIndex(): boolean {
//        if (this.BpIndex >= 0) {
//            return true;
//        }
//        return false;
//    }

//    public IfName: string;
//    public get HasRemoteIfEntry(): boolean {
//        if (this.IfName != null) {
//            return true;
//        }

//        return false;
//    }

//    public MacAddress: MacAddress;
//    public get HasMacAddress(): boolean {
//        if (this.MacAddress != null) {
//            return !this.MacAddress.IsNull;
//        }

//        return false;
//    }

//    public RemoteDevice: Device;
//    public get HasRemoteDevice(): boolean {
//        if (this.RemoteDevice != null) {
//            return true;
//        }

//        return false;
//    }

//    public RemoteIpAddress: IpAddress;
//    public get GetRemoteIpAddress(): IpAddress {
//        if (this.RemoteIpAddress != null && this.RemoteDevice.HasIpAddress) {
//            return this.RemoteDevice.IpAddress;
//        }

//        return IpAddress.CreateByVersion(IpVersion.IPv4);
//    }

//    private CachedRemoteVendorName: string;
//    private get HasCachedRemoteVendorName(): boolean {
//        if (this.CachedRemoteVendorName == null
//            || this.CachedRemoteVendorName.length == 0) {
//            return false;
//        }

//        return true;
//    }

//    public RemoteVendorName: string;
//    public get GetRemoteVendorName(): string {
//        if (!this.HasCachedRemoteVendorName) {
//            //this.cachedRemoteVendorName;
//            // TODO: find vendor name via DiscoveryEngine... See FdbTable.cs
//        }
//        return "VENDORNAME PLACEHOLDER";
//    }

//    Write(obj: any, context: any): void {
//        throw new Error("Method not implemented.");
//    }
//    Read(obj: any, context: any): void {
//        throw new Error("Method not implemented.");
//    }

//}

export class BridgePortFdbTable extends InfoSet {
	//public static FromJson(json: InfoSetEntriesJson<BridgePortFdbEntryJson>, device:Device): BridgePortFdbTable {
	//	var result = new BridgePortFdbTable(device);

	//	json.entries.forEach((bpEntry) => {
	//		result.AddEntry(FdbEntry.FromJson(bpEntry.bridge_port_fdb_entry));
	//	});

	//	return result;
	//}
		
	private _bpsFdbTable: Dictionary<number, FdbTable>;

	constructor(device: Device) {
		super(device);
		this._bpsFdbTable = new Dictionary<number, FdbTable>();
	}

	private AddEntry(fdbEntry: FdbEntry) :void {
		if (fdbEntry && fdbEntry.BpIndex >= 0) {
			var fdbTable: FdbTable = this._bpsFdbTable.Item(fdbEntry.BpIndex);
				
			if (!fdbTable) {
				fdbTable = new FdbTable();
				this._bpsFdbTable.Add(fdbEntry.BpIndex, fdbTable);
			}
				
			fdbTable.AddEntry(fdbEntry);
		}
	}

	public Add(macAddress: MacAddress, bpIndex: number): FdbEntry {
		var fdbTable: FdbTable = this._bpsFdbTable.Item(bpIndex);

		if (!fdbTable) {
			fdbTable = new FdbTable();
			this._bpsFdbTable.Add(bpIndex, fdbTable);
		}

		return fdbTable.Add(macAddress, bpIndex);
	}

	public Remove(macAddress: MacAddress, bpIndex:number):boolean {
		var fdbTable: FdbTable = this._bpsFdbTable.Item(bpIndex);

		if (fdbTable) {
			if (fdbTable.Remove(macAddress, bpIndex)) {
				if (fdbTable.Count == 0)
					this._bpsFdbTable.Remove(bpIndex);

				return true;
			}
		}
			
		return false;
	}

	public Find(bpIndex: number): FdbTable {
		return this._bpsFdbTable.Item(bpIndex);
	}

	public Clear():void {
		this._bpsFdbTable.Clear();
	}

	public get Count():	number {
		return this._bpsFdbTable.Count;
	}

	public get HasMacSightings(): boolean {
		return true;
	}

	public get MacSightings(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		this._bpsFdbTable.ForEach((pair) => {
			pair.Value.ForEach((fdbEntry: FdbEntry) => {
				if (fdbEntry.HasMacAddress) {
					macAddresses.Add(fdbEntry.MacAddress);
				}
			});
		});
			
		return (macAddresses);
	}

	public ForEach(callbackfn: (value: FdbTable, index: number, array: FdbTable[]) => void, thisArg?: any): void {
		this._bpsFdbTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: FdbTable, index: number, array: FdbTable[]) => boolean, thisArg?: any): boolean {
		return this._bpsFdbTable.Values().Some(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.bp_fdb_info = {};
		obj = obj.bp_fdb_info;

		obj.entries = [];
		this._bpsFdbTable.Values().ForEach((fdbTable: FdbTable) => {
			fdbTable.ForEach((fdbEntry: FdbEntry) => {
				if (fdbEntry.HasBpIndex) {
					let elem: any = {
						bridge_port_fdb_entry: {
							bridge_port_index: ValueEncoder.EncodeInteger(fdbEntry.BpIndex),
							mac_address: ValueEncoder.EncodeMacAddress(fdbEntry.MacAddress)
						}
					};

					if (fdbEntry.HasStatus) {
						elem.bridge_port_fdb_entry.status = ValueEncoder.EncodeInteger(fdbEntry.Status);
					}

					obj.entries.push(elem);
				}
			}, this);
		}, this);
	}

	public Read(obj: any, context: any): void {
		if (!obj.bp_fdb_info)
			throw new Error();
		obj = obj.bp_fdb_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((elem: any) => {
				if (!elem.bridge_port_fdb_entry)
					throw new Error();
				elem = elem.bridge_port_fdb_entry;

				let fdbEntry = new FdbEntry();

				if (elem.bridge_port_index !== undefined) {
					fdbEntry.BpIndex = ValueEncoder.DecodeInteger(elem.bridge_port_index);
				}

				if (elem.mac_address !== undefined) {
					fdbEntry.MacAddress = ValueEncoder.DecodeMacAddress(elem.mac_address);
				}

				if (elem.status !== undefined) {
					fdbEntry.Status = ValueEncoder.DecodeInteger(elem.status);
				}

				this.AddEntry(fdbEntry);
			}, this);
		}
	}
}
